import React, { FC } from "react";
import { Switch } from "@mui/material";
import cn from "classnames";

import styles from "./SwitchField.module.css";

interface Props {
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

const SwitchField: FC<Props> = ({ label, checked, onChange, disabled }) => {
  return (
    <div
      className={cn(styles.container, {
        [styles.containerDisabled]: disabled,
      })}
    >
      <Switch
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className={styles.switch}
      />
      <span className={styles.label}>{label}</span>
    </div>
  );
};

export default SwitchField;
